import { Tab, Tabs } from "@heroui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import AthletesList from "./athletesList";
import ManagerList from "./managerList";

const ProfileList: React.FC = () => {
  const { t } = useTranslation("sidebar");
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedTab = searchParams.get("type") === "manager" ? "manager" : "athletes";

  const handleTabChange = (key: React.Key) => {
    setSearchParams({ ...Object.fromEntries(searchParams), type: String(key) }, { replace: true });
  };

  const tabs = (
    <Tabs selectedKey={selectedTab} onSelectionChange={handleTabChange} aria-label={t("profileList", "Profile list")}>
      <Tab key="athletes" title={t("athlete", "Athlete")} />
      <Tab key="manager" title={t("organisations", "Organisations")} />
    </Tabs>
  );

  return (
    <div className="w-full">
      <div className="bg-white px-6 py-4 lg:hidden">{tabs}</div>

      {selectedTab === "manager" ? <ManagerList profileTabs={tabs} /> : <AthletesList profileTabs={tabs} />}
    </div>
  );
};

export default ProfileList;
